export enum ScrollIntoView {
    /**
     * Doesn't scroll
     */
    None,
    /**
     * Scroll to top
     */
    Top,

    /**
     * Scroll to middle
     */
    Middle,

    /**
     * Scroll to bottom
     */
    Bottom,
}

export default interface ScrollIntoViewInfo {
    /**
     * Top position of the dummy time indicator for the scrollIntoView
     */
    topPosition: number;

    /**
     * Where to scrollIntoView
     */
    scrollIntoViewType: ScrollIntoView;
}
